import { html } from 'lit-html';
import { LitElement, css } from 'lit-element';

class BreakerTypeBlock extends LitElement {
    static properties = {
        imgSrc: { type: String }
    };

    static styles = css`
        .breaker_type_block
        {
            display: inline-block;
            height: 1em;
            padding: 5px;
        }

        .breaker_type_block img
        {
            height: 100%;
        }
    `;

    constructor(imgSrc) {
        super();
        this.imgSrc = imgSrc; // Значение по умолчанию
    }

    render() {
        return html`
            <div class="breaker_type_block">
                <img src="${this.imgSrc}">
            </div>
        `;
    }
}

// Регистрация компонента
customElements.define('breaker-type-block', BreakerTypeBlock);

export function CreateBreakerTypeBlock(img_path)
{
    let breakerTypeBlock = new BreakerTypeBlock(img_path);

    return breakerTypeBlock;
}